export default __webpack_public_path__ + "static/media/samplePdf2.9bbfcb5d.pdf";